// Country dial codes for the FillApp phone control (mirrors the Common App
// ca-phone country-code dropdown). US first, then alphabetical by name.
export type DialCode = { dial: string; name: string };

export const DIAL_CODES: DialCode[] = [
    { dial: '+1', name: 'United States' },
    { dial: '+93', name: 'Afghanistan' },
    { dial: '+355', name: 'Albania' },
    { dial: '+213', name: 'Algeria' },
    { dial: '+376', name: 'Andorra' },
    { dial: '+244', name: 'Angola' },
    { dial: '+1264', name: 'Anguilla' },
    { dial: '+1268', name: 'Antigua and Barbuda' },
    { dial: '+54', name: 'Argentina' },
    { dial: '+374', name: 'Armenia' },
    { dial: '+297', name: 'Aruba' },
    { dial: '+61', name: 'Australia' },
    { dial: '+43', name: 'Austria' },
    { dial: '+994', name: 'Azerbaijan' },
    { dial: '+1242', name: 'Bahamas' },
    { dial: '+973', name: 'Bahrain' },
    { dial: '+880', name: 'Bangladesh' },
    { dial: '+1246', name: 'Barbados' },
    { dial: '+375', name: 'Belarus' },
    { dial: '+32', name: 'Belgium' },
    { dial: '+501', name: 'Belize' },
    { dial: '+229', name: 'Benin' },
    { dial: '+1441', name: 'Bermuda' },
    { dial: '+975', name: 'Bhutan' },
    { dial: '+591', name: 'Bolivia' },
    { dial: '+387', name: 'Bosnia and Herzegovina' },
    { dial: '+267', name: 'Botswana' },
    { dial: '+55', name: 'Brazil' },
    { dial: '+673', name: 'Brunei' },
    { dial: '+359', name: 'Bulgaria' },
    { dial: '+226', name: 'Burkina Faso' },
    { dial: '+257', name: 'Burundi' },
    { dial: '+855', name: 'Cambodia' },
    { dial: '+237', name: 'Cameroon' },
    { dial: '+1', name: 'Canada' },
    { dial: '+238', name: 'Cape Verde' },
    { dial: '+1345', name: 'Cayman Islands' },
    { dial: '+236', name: 'Central African Republic' },
    { dial: '+235', name: 'Chad' },
    { dial: '+56', name: 'Chile' },
    { dial: '+86', name: 'China' },
    { dial: '+57', name: 'Colombia' },
    { dial: '+269', name: 'Comoros' },
    { dial: '+242', name: 'Congo' },
    { dial: '+243', name: 'Congo (DRC)' },
    { dial: '+682', name: 'Cook Islands' },
    { dial: '+506', name: 'Costa Rica' },
    { dial: '+225', name: "Côte d'Ivoire" },
    { dial: '+385', name: 'Croatia' },
    { dial: '+53', name: 'Cuba' },
    { dial: '+599', name: 'Curaçao' },
    { dial: '+357', name: 'Cyprus' },
    { dial: '+420', name: 'Czechia' },
    { dial: '+45', name: 'Denmark' },
    { dial: '+253', name: 'Djibouti' },
    { dial: '+1767', name: 'Dominica' },
    { dial: '+1809', name: 'Dominican Republic' },
    { dial: '+593', name: 'Ecuador' },
    { dial: '+20', name: 'Egypt' },
    { dial: '+503', name: 'El Salvador' },
    { dial: '+240', name: 'Equatorial Guinea' },
    { dial: '+291', name: 'Eritrea' },
    { dial: '+372', name: 'Estonia' },
    { dial: '+268', name: 'Eswatini' },
    { dial: '+251', name: 'Ethiopia' },
    { dial: '+679', name: 'Fiji' },
    { dial: '+358', name: 'Finland' },
    { dial: '+33', name: 'France' },
    { dial: '+594', name: 'French Guiana' },
    { dial: '+689', name: 'French Polynesia' },
    { dial: '+241', name: 'Gabon' },
    { dial: '+220', name: 'Gambia' },
    { dial: '+995', name: 'Georgia' },
    { dial: '+49', name: 'Germany' },
    { dial: '+233', name: 'Ghana' },
    { dial: '+350', name: 'Gibraltar' },
    { dial: '+30', name: 'Greece' },
    { dial: '+299', name: 'Greenland' },
    { dial: '+1473', name: 'Grenada' },
    { dial: '+590', name: 'Guadeloupe' },
    { dial: '+1671', name: 'Guam' },
    { dial: '+502', name: 'Guatemala' },
    { dial: '+224', name: 'Guinea' },
    { dial: '+245', name: 'Guinea-Bissau' },
    { dial: '+592', name: 'Guyana' },
    { dial: '+509', name: 'Haiti' },
    { dial: '+504', name: 'Honduras' },
    { dial: '+852', name: 'Hong Kong' },
    { dial: '+36', name: 'Hungary' },
    { dial: '+354', name: 'Iceland' },
    { dial: '+91', name: 'India' },
    { dial: '+62', name: 'Indonesia' },
    { dial: '+98', name: 'Iran' },
    { dial: '+964', name: 'Iraq' },
    { dial: '+353', name: 'Ireland' },
    { dial: '+972', name: 'Israel' },
    { dial: '+39', name: 'Italy' },
    { dial: '+1876', name: 'Jamaica' },
    { dial: '+81', name: 'Japan' },
    { dial: '+962', name: 'Jordan' },
    { dial: '+7', name: 'Kazakhstan' },
    { dial: '+254', name: 'Kenya' },
    { dial: '+686', name: 'Kiribati' },
    { dial: '+965', name: 'Kuwait' },
    { dial: '+996', name: 'Kyrgyzstan' },
    { dial: '+856', name: 'Laos' },
    { dial: '+371', name: 'Latvia' },
    { dial: '+961', name: 'Lebanon' },
    { dial: '+266', name: 'Lesotho' },
    { dial: '+231', name: 'Liberia' },
    { dial: '+218', name: 'Libya' },
    { dial: '+423', name: 'Liechtenstein' },
    { dial: '+370', name: 'Lithuania' },
    { dial: '+352', name: 'Luxembourg' },
    { dial: '+853', name: 'Macau' },
    { dial: '+261', name: 'Madagascar' },
    { dial: '+265', name: 'Malawi' },
    { dial: '+60', name: 'Malaysia' },
    { dial: '+960', name: 'Maldives' },
    { dial: '+223', name: 'Mali' },
    { dial: '+356', name: 'Malta' },
    { dial: '+692', name: 'Marshall Islands' },
    { dial: '+596', name: 'Martinique' },
    { dial: '+222', name: 'Mauritania' },
    { dial: '+230', name: 'Mauritius' },
    { dial: '+52', name: 'Mexico' },
    { dial: '+691', name: 'Micronesia' },
    { dial: '+373', name: 'Moldova' },
    { dial: '+377', name: 'Monaco' },
    { dial: '+976', name: 'Mongolia' },
    { dial: '+382', name: 'Montenegro' },
    { dial: '+1664', name: 'Montserrat' },
    { dial: '+212', name: 'Morocco' },
    { dial: '+258', name: 'Mozambique' },
    { dial: '+95', name: 'Myanmar' },
    { dial: '+264', name: 'Namibia' },
    { dial: '+674', name: 'Nauru' },
    { dial: '+977', name: 'Nepal' },
    { dial: '+31', name: 'Netherlands' },
    { dial: '+687', name: 'New Caledonia' },
    { dial: '+64', name: 'New Zealand' },
    { dial: '+505', name: 'Nicaragua' },
    { dial: '+227', name: 'Niger' },
    { dial: '+234', name: 'Nigeria' },
    { dial: '+850', name: 'North Korea' },
    { dial: '+389', name: 'North Macedonia' },
    { dial: '+1670', name: 'Northern Mariana Islands' },
    { dial: '+47', name: 'Norway' },
    { dial: '+968', name: 'Oman' },
    { dial: '+92', name: 'Pakistan' },
    { dial: '+680', name: 'Palau' },
    { dial: '+970', name: 'Palestine' },
    { dial: '+507', name: 'Panama' },
    { dial: '+675', name: 'Papua New Guinea' },
    { dial: '+595', name: 'Paraguay' },
    { dial: '+51', name: 'Peru' },
    { dial: '+63', name: 'Philippines' },
    { dial: '+48', name: 'Poland' },
    { dial: '+351', name: 'Portugal' },
    { dial: '+1787', name: 'Puerto Rico' },
    { dial: '+974', name: 'Qatar' },
    { dial: '+262', name: 'Réunion' },
    { dial: '+40', name: 'Romania' },
    { dial: '+7', name: 'Russia' },
    { dial: '+250', name: 'Rwanda' },
    { dial: '+1869', name: 'Saint Kitts and Nevis' },
    { dial: '+1758', name: 'Saint Lucia' },
    { dial: '+1784', name: 'Saint Vincent and the Grenadines' },
    { dial: '+685', name: 'Samoa' },
    { dial: '+378', name: 'San Marino' },
    { dial: '+239', name: 'São Tomé and Príncipe' },
    { dial: '+966', name: 'Saudi Arabia' },
    { dial: '+221', name: 'Senegal' },
    { dial: '+381', name: 'Serbia' },
    { dial: '+248', name: 'Seychelles' },
    { dial: '+232', name: 'Sierra Leone' },
    { dial: '+65', name: 'Singapore' },
    { dial: '+421', name: 'Slovakia' },
    { dial: '+386', name: 'Slovenia' },
    { dial: '+677', name: 'Solomon Islands' },
    { dial: '+252', name: 'Somalia' },
    { dial: '+27', name: 'South Africa' },
    { dial: '+82', name: 'South Korea' },
    { dial: '+211', name: 'South Sudan' },
    { dial: '+34', name: 'Spain' },
    { dial: '+94', name: 'Sri Lanka' },
    { dial: '+249', name: 'Sudan' },
    { dial: '+597', name: 'Suriname' },
    { dial: '+46', name: 'Sweden' },
    { dial: '+41', name: 'Switzerland' },
    { dial: '+963', name: 'Syria' },
    { dial: '+886', name: 'Taiwan' },
    { dial: '+992', name: 'Tajikistan' },
    { dial: '+255', name: 'Tanzania' },
    { dial: '+66', name: 'Thailand' },
    { dial: '+670', name: 'Timor-Leste' },
    { dial: '+228', name: 'Togo' },
    { dial: '+676', name: 'Tonga' },
    { dial: '+1868', name: 'Trinidad and Tobago' },
    { dial: '+216', name: 'Tunisia' },
    { dial: '+90', name: 'Turkey' },
    { dial: '+993', name: 'Turkmenistan' },
    { dial: '+1649', name: 'Turks and Caicos Islands' },
    { dial: '+688', name: 'Tuvalu' },
    { dial: '+256', name: 'Uganda' },
    { dial: '+380', name: 'Ukraine' },
    { dial: '+971', name: 'United Arab Emirates' },
    { dial: '+44', name: 'United Kingdom' },
    { dial: '+598', name: 'Uruguay' },
    { dial: '+998', name: 'Uzbekistan' },
    { dial: '+678', name: 'Vanuatu' },
    { dial: '+58', name: 'Venezuela' },
    { dial: '+84', name: 'Vietnam' },
    { dial: '+1284', name: 'Virgin Islands (British)' },
    { dial: '+1340', name: 'Virgin Islands (U.S.)' },
    { dial: '+967', name: 'Yemen' },
    { dial: '+260', name: 'Zambia' },
    { dial: '+263', name: 'Zimbabwe' },
];
